module.exports = __webpack_public_path__ + "assets/img/5.5b19620c.png";